import React from 'react';
import { connect } from 'react-redux'
import { _getToken, _error, _success, _validationFormMsg, _setAxios, _tableLogActivity } from '../../../lib/Helper';
import { jenisInstansiOptions, frekuensiOptions } from '../../../data/options';
import { schemaPendidikan } from '../schema';
import { Input, Tooltip, Table, Row, Col, Divider, Popover, Modal, Button, Radio, Space, Menu, Dropdown } from 'antd';
import { PageHeader } from 'components/header';
import { InfoCircleOutlined, SearchOutlined, ArrowUpOutlined, ArrowDownOutlined, PlusOutlined, SortAscendingOutlined, EditOutlined, DeleteOutlined, ExclamationCircleOutlined, SettingOutlined, DownCircleOutlined } from '@ant-design/icons';
import axios from 'axios';
import validate from 'validate.js';
import TextField from '@mui/material/TextField';

import Autocomplete from '@mui/material/Autocomplete';
import AdapterDateFns from '@mui/lab/AdapterDateFns';
import LocalizationProvider from '@mui/lab/LocalizationProvider';
import MobileDatePicker from '@mui/lab/MobileDatePicker';

class Pendidikan extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            tableOption: {
                sortField: "id",
                sortValue: "DESC",
            },
            data: [],
            search: "",
            pagination: {
                current: 1,
                pageSize: 10,
            },
            loading: false,
            visibleModalCreate: false,
            id: 0,
            values: {},
            errors: {},
            create: {
                visible: false,
                loading: false,
            },
            update: {
                visible: false,
                loading: false,
            },
            delete: {
                loading: false,
            },
            dataID: this.props.dataID
        };
    }

    componentDidMount() {
        this.fetchTable()
    }

    fetchTable = () => {
        var params = {
            search: this.state.search,
            pagination: { ...this.state.pagination },
            sorting: [{
                field: this.state.tableOption.sortField,
                sort: this.state.tableOption.sortValue,
                urutan: 1,
            }]
        }
        this.fetch(params);
    }


    handleTableChange = (pagination, filters, sorter) => {
        this.fetch({
            sortField: sorter.field,
            sortOrder: sorter.order,
            pagination,
            ...filters,
            search: this.state.search,
            sorting: [{
                field: this.state.tableOption.sortField,
                sort: this.state.tableOption.sortValue,
                urutan: 1,
            }]
        });
    };

    handleTableSearch = (e) => {
        const { value } = e.target;

        this.setState({
            search: value,
        });

        var params = {
            search: value,
            pagination: { ...this.state.pagination, current: 1 },
            sorting: [{
                field: this.state.tableOption.sortField,
                sort: this.state.tableOption.sortValue,
                urutan: 1,
            }]
        }
        this.fetch(params);

    };

    handleTableFilter = e => {
        this.setState({
            tableOption: {
                ...this.state.tableOption,
                sortField: e.target.value
            },
        });

        this.fetch({
            search: this.state.search,
            pagination: { ...this.state.pagination },
            sorting: [{
                field: e.target.value,
                sort: this.state.tableOption.sortValue,
                urutan: 1,
            }]
        });
    };

    handleTableSort = e => {
        this.setState({
            tableOption: {
                ...this.state.tableOption,
                sortValue: e.target.value
            },
        });

        this.fetch({
            search: this.state.search,
            pagination: { ...this.state.pagination },
            sorting: [{
                field: this.state.tableOption.sortField,
                sort: e.target.value,
                urutan: 1,
            }]
        });
    };

    fetch = async (params = {}) => {
        this.setState({ loading: true });
        const headers = {
            'Accept': 'application/json',
            'Authorization': _getToken()
        };

        axios.post(process.env.REACT_APP_API_URL + '/siswa/pendidikan/table/' + this.state.dataID, JSON.stringify(params), { headers })
            .then((resp) => {
                this.setState({
                    loading: false,
                    data: resp.data.list,
                    pagination: {
                        ...params.pagination,
                        total: resp.data.info.total,
                    },
                });
            })
            .catch(function (error) {
                if (error.response.data.message) {
                    _error('topRight', 'Failed', error.response.data.message)
                }
            });
    };

    handleChange = (e) => {
        const { name, value } = e.target;
        this.setForm(name, value)
    };

    handleChangeSetValue = (name, value) => {
        this.setForm(name, value)
    };

    setForm = (name, value, row = {}) => {
        const { values } = this.state;
        values[name] = value;
        const errors = validate(values, schemaPendidikan);
        this.setState({
            values: values,
            errors: errors || {},
        });
    }

    hasError = field => {
        return this.state.errors[field] ? true : false;
    }

    resetForm = () => {
        this.setState({
            values: {},
            errors: {},
        });
    };


    // CREATE START ------------------------------------------
    showModalCreate = () => {
        this.setState({
            create: {
                ...this.state.create,
                visible: true,
            },

        });
    };

    hideModalCreate = () => {
        this.setState({
            create: {
                visible: false,
                loading: false,
            },

        });
    };

    createSubmitPendidikan = (e) => {
        e.preventDefault();
        const { values } = this.state;
        const errors = validate(values, schemaPendidikan);
        if (errors) {
            return _validationFormMsg(errors)
        }

        const params = [{
            "tahun_belajar": values.pendidikan_tahun && values.pendidikan_tahun instanceof Date ? values.pendidikan_tahun.getFullYear() : null,
            "nama_lembaga": values.pendidikan_nama_lembaga ? values.pendidikan_nama_lembaga : null,
            "jenis_lembaga": values.pendidikan_jenis_lembaga ? values.pendidikan_jenis_lembaga.value : null,
            "frekuensi_belajar": values.pendidikan_frekuensi_belajar ? values.pendidikan_frekuensi_belajar.value : null,
            "lokasi_lembaga": values.pendidikan_lokasi_lembaga ? values.pendidikan_lokasi_lembaga : null,
        }]

        this.setState({
            create: {
                ...this.state.create,
                loading: true
            }
        });

        _setAxios("siswa/pendidikan/" + this.state.dataID, "POST", params).then(resp => {
            if (resp.status === true) {
                this.hideModalCreate()
                this.resetForm()
                this.fetchTable()
                _success('topRight', 'Success', resp.data.message)
            } else {
                this.setState({
                    create: {
                        ...this.state.create,
                        loading: false
                    }
                });
            }
        })
    };

    // CREATE END ------------------------------------------

    // UPDATE START ------------------------------------------
    showModalUpdate = (row) => {
        console.log(row, row)
        this.setState({
            update: {
                visible: true,
                loading: false
            },

            id: row.id,
            values: {
                pendidikan_nama_lembaga: row.nama_lembaga,
                pendidikan_jenis_lembaga: {
                    value: row.jenis_lembaga,
                    label: row.jenis_lembaga,
                },
                pendidikan_tahun: new Date(row.tahun_belajar, 11, 24, 10, 33, 30, 0),
                pendidikan_frekuensi_belajar: {
                    value: row.frekuensi_belajar,
                    label: row.frekuensi_belajar,
                },
                pendidikan_lokasi_lembaga: row.lokasi_lembaga,

            }
        });
    };

    hideModalUpdate = () => {
        this.setState({
            update: {
                visible: false,
                loading: false
            }
        });
    };

    updateSubmitPendidikan = (e) => {
        e.preventDefault();
        const { values } = this.state;
        const errors = validate(values, schemaPendidikan);
        if (errors) {
            return _validationFormMsg(errors)
        }

        const params = {
            "tahun_belajar": values.pendidikan_tahun && values.pendidikan_tahun instanceof Date ? values.pendidikan_tahun.getFullYear() : null,
            "nama_lembaga": values.pendidikan_nama_lembaga ? values.pendidikan_nama_lembaga : null,
            "jenis_lembaga": values.pendidikan_jenis_lembaga ? values.pendidikan_jenis_lembaga.value : null,
            "frekuensi_belajar": values.pendidikan_frekuensi_belajar ? values.pendidikan_frekuensi_belajar.value : null,
            "lokasi_lembaga": values.pendidikan_lokasi_lembaga ? values.pendidikan_lokasi_lembaga : null,
        }

        this.setState({
            update: {
                ...this.state.update,
                loading: true
            }
        });
        _setAxios("siswa/pendidikan/" + this.state.id, "PUT", params).then(resp => {
            if (resp.status === true) {
                this.hideModalUpdate()
                this.resetForm()
                this.fetchTable()
                _success('topRight', 'Success', resp.data.message)
            } else {
                this.setState({
                    update: {
                        ...this.state.update,
                        loading: false
                    }
                });
            }
        })

    };
    // UPDATE END ------------------------------------------

    // DELETE START ------------------------------------------
    onDeleteSubmitPendidikan = (row) => {
        Modal.confirm({
            title: 'Apakah Anda yakin?',
            icon: <ExclamationCircleOutlined />,
            content: 'Pendidikan [' + row.nama_lembaga + '] akan dihapus dari list.',
            onOk: () => {
                this.setState({
                    delete: {
                        loading: true
                    }
                });

                _setAxios("siswa/pendidikan/" + row.id, "DELETE").then(resp => {
                    if (resp.status === true) {
                        this.setState({
                            delete: {
                                loading: false
                            }
                        });
                        _success('topRight', 'Success', resp.data.message)
                        this.fetchTable()
                    } else {
                        this.setState({
                            delete: {
                                loading: false
                            }
                        });
                    }
                })
            },
            onCancel: () => {
                console.log("No action to process")
            },
        });
    };

    // DELETE END ------------------------------------------


    render() {
        const action = this.props.action
        const { data, pagination, loading, values, errors, tableOption } = this.state;

        const sortComponent = <>
            <Radio.Group onChange={this.handleTableFilter} value={tableOption.sortField} name="sort_field">
                <Space direction="vertical">
                    <Radio value="nama">Nama</Radio>
                    <Radio value="id">Tanggal Pembuatan</Radio>
                </Space>
            </Radio.Group>

            <Divider orientation="left"></Divider>

            <Radio.Group onChange={this.handleTableSort} value={tableOption.sortValue} name="sort_value">
                <Space direction="vertical">
                    <Radio value="ASC"><ArrowUpOutlined /> Ascending</Radio>
                    <Radio value="DESC"><ArrowDownOutlined /> Descending</Radio>
                </Space>
            </Radio.Group>
        </>

        const formInput = <>
            <Row gutter={[24, 24]}>

                <Col xs={24}>
                    <TextField
                        fullWidth
                        label="Nama Lembaga *"
                        size="small"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        name="pendidikan_nama_lembaga"
                        type="text"
                        onChange={this.handleChange}
                        value={values.pendidikan_nama_lembaga || ""}
                        error={this.hasError('pendidikan_nama_lembaga')}
                        helperText={
                            this.hasError('pendidikan_nama_lembaga') ? errors.pendidikan_nama_lembaga[0] : null
                        }
                    />
                </Col>
                <Col xs={24}>
                    <Autocomplete
                        options={jenisInstansiOptions}
                        value={values.pendidikan_jenis_lembaga || null}
                        onChange={(e, newValue) => {
                            this.handleChangeSetValue("pendidikan_jenis_lembaga", newValue)
                        }}
                        name="pendidikan_jenis_lembaga"
                        renderInput={(params) => <TextField {...params}
                            fullWidth
                            label="Jenis Lembaga *"
                            size="small"
                            error={this.hasError('pendidikan_jenis_lembaga')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            helperText={
                                this.hasError('pendidikan_jenis_lembaga') ? errors.pendidikan_jenis_lembaga[0] : null
                            }
                        />}
                    />
                </Col>
                <Col xs={12} sm={12}>
                    <LocalizationProvider dateAdapter={AdapterDateFns}>
                        <MobileDatePicker
                            views={['year']}
                            disableHighlightToday={true}
                            label="Mulai Belajar *"
                            value={values.pendidikan_tahun || ""}
                            onChange={(newValue) => {
                                this.handleChangeSetValue("pendidikan_tahun", newValue)
                            }}
                            renderInput={(params) => <TextField {...params}
                                fullWidth
                                size="small"
                                error={this.hasError('pendidikan_tahun')}
                                InputLabelProps={{
                                    shrink: true,
                                }}
                                helperText={
                                    this.hasError('pendidikan_tahun') ? errors.pendidikan_tahun[0] : null
                                }
                            />}
                        />
                    </LocalizationProvider>
                </Col>
                <Col xs={24} sm={12}>
                    <Autocomplete
                        options={frekuensiOptions}
                        value={values.pendidikan_frekuensi_belajar || null}
                        onChange={(e, newValue) => {
                            this.handleChangeSetValue("pendidikan_frekuensi_belajar", newValue)
                        }}
                        name="pendidikan_frekuensi_belajar"
                        renderInput={(params) => <TextField {...params}
                            fullWidth
                            label="Frekuensi Belajar *"
                            size="small"
                            error={this.hasError('pendidikan_frekuensi_belajar')}
                            InputLabelProps={{
                                shrink: true,
                            }}
                            helperText={
                                this.hasError('pendidikan_frekuensi_belajar') ? errors.pendidikan_frekuensi_belajar[0] : null
                            }
                        />}
                    />
                </Col>
                <Col xs={24}>
                    <TextField
                        fullWidth
                        label="Lokasi Lembaga *"
                        size="small"
                        InputLabelProps={{
                            shrink: true,
                        }}
                        name="pendidikan_lokasi_lembaga"
                        type="text"
                        onChange={this.handleChange}
                        value={values.pendidikan_lokasi_lembaga || ""}
                        error={this.hasError('pendidikan_lokasi_lembaga')}
                        helperText={
                            this.hasError('pendidikan_lokasi_lembaga') ? errors.pendidikan_lokasi_lembaga[0] : null
                        }
                    />
                </Col>
            </Row>
        </>

        const modalCreate = <Modal
            title="Tambah Pendidikan"
            open={this.state.create.visible}
            onCancel={this.hideModalCreate}
            footer={<>
                <Button onClick={this.hideModalCreate}>Batal</Button>
                <Button type="primary" htmlType="submit" onClick={this.createSubmitPendidikan} loading={this.state.create.loading}>Simpan</Button>
            </>}
        >
            <form autoComplete="off" onSubmit={this.createSubmitPendidikan}>
                {formInput}
            </form>
        </Modal>

        const modalUpdate = <Modal
            title="Update Pendidikan"
            onCancel={this.hideModalUpdate}
            open={this.state.update.visible}
            footer={<>
                <Button onClick={this.hideModalUpdate}>Batal</Button>
                <Button type="primary" htmlType="submit" onClick={this.updateSubmitPendidikan} loading={this.state.update.loading}>Simpan</Button>
            </>}

        >
            <form autoComplete="off" onSubmit={this.updateSubmitPendidikan}>
                {formInput}
            </form>
        </Modal>

        const modalDelete = <Modal
            title={<><ExclamationCircleOutlined /> Confirm</>}
            open={this.state.delete.visible}
            onCancel={this.hideModalDelete}
            footer={<>
                <Button onClick={this.hideModalDelete}>Batal</Button>
                <Button type="primary" htmlType="submit" onClick={this.deleteSubmit} loading={this.state.delete.loading}>Simpan</Button>
            </>}
        >
            Apakah Anda Yakin?

        </Modal>

        return (
            <>
                <PageHeader
                    className="site-page-header"
                    title="Pendidikan"
                    extra={
                        action.education_create ? <Button type='primary' className='nav-btn-page' icon={<PlusOutlined />} onClick={this.showModalCreate}> Tambah</Button> : ""
                    }
                />
                <Row gutter={[16, 16]}>
                    <Col xs={16} sm={18} md={20} lg={22}>
                        <Input
                            name="search"
                            className='search-table'
                            placeholder="Search..."
                            prefix={<SearchOutlined className="site-form-item-icon" />}
                            onChange={this.handleTableSearch}
                            value={this.state.search || ""}
                            suffix={
                                <Tooltip title="Cari berdasarkan nama">
                                    <InfoCircleOutlined style={{ color: 'rgba(0,0,0,.45)' }} />
                                </Tooltip>
                            }
                        />
                    </Col>
                    <Col xs={8} sm={6} md={4} lg={2} className="text-align-right">
                        <Popover placement="bottom" content={sortComponent} trigger="click">
                            <Button block><SortAscendingOutlined /> Sort</Button>
                        </Popover>
                    </Col>
                </Row>

                <Divider orientation="left"></Divider>

                <Row>
                    <Col span={24}>
                        <Table
                            columns={[
                                {
                                    title: 'No',
                                    dataIndex: 'rownum',
                                    sorter: false,
                                    width: '3%',
                                },
                                {
                                    title: 'Lembaga',
                                    dataIndex: 'nama_lembaga',
                                    sorter: false,
                                },
                                {
                                    title: 'Jenis Lembaga',
                                    dataIndex: 'jenis_lembaga',
                                    sorter: false,
                                },
                                {
                                    title: 'Mulai Belajar',
                                    dataIndex: 'tahun_belajar',
                                    sorter: false,
                                },
                                {
                                    title: 'Frekuensi Belajar',
                                    dataIndex: 'frekuensi_belajar',
                                    sorter: false,
                                },
                                {
                                    title: 'Lokasi Lembaga',
                                    dataIndex: 'lokasi_lembaga',
                                    sorter: false,
                                },
                                {
                                    title: <SettingOutlined />,
                                    align: "center",
                                    key: 'operation',
                                    width: '2%',
                                    render: (a, row) => <Dropdown trigger={['click']} menu={<Menu>
                                        {action.education_update === true ? (<Menu.Item key={0} onClick={this.showModalUpdate.bind(this, row)}><EditOutlined /> Update</Menu.Item>) : ""}
                                        {action.education_delete === true ? (<Menu.Item key={1} onClick={this.onDeleteSubmitPendidikan.bind(this, row)}><DeleteOutlined /> Delete</Menu.Item>) : ""}
                                    </Menu>}>
                                        <Button type="primary">Opsi <DownCircleOutlined style={{ fontSize: 11 }} /></Button>
                                    </Dropdown>,
                                },
                                {
                                    title: 'LogActivity',
                                    key: 'operation',
                                    width: '10%',
                                    render: (a, row) => _tableLogActivity(row),
                                },
                            ]}
                            rowKey={record => record.id}
                            dataSource={data}
                            pagination={pagination}
                            loading={loading}
                            onChange={this.handleTableChange}
                            size="small"
                        />
                    </Col>
                </Row>

                {modalCreate}

                {modalUpdate}

                {modalDelete}

            </>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        privilege: state.privilege,
    }
}

export default connect(mapStateToProps)(Pendidikan);
